import { createReducer } from '../../helpers';
import { api } from '../../actions';

const initialState = {};

export default createReducer(initialState, {
    [api.conversations.unread.success]: (state, action) => {
        return action.result;
    },
    [api.conversations.read.success]: (state, action) => {
        state[action.contactId] = 0;
    },
});
